import {
    dashboardCountUrl,
    dateOpenUrl,
    dayCloseUrl,
    getCurrentDayOpenUrl,
    getorderListUrl,
    paymentGroupByPaymentMethodUrl,
    categorySalesSummaryUrl,
    creditSaleSummaryUrl,
    deleteTodayDayUrl
} from "../api";
import {hideLoader, showLoader} from "../../../actions/loader";
import {notification} from "../../../components/Elements/appUtils";
import axios from "axios";
import {getToken} from "../../../request";


export const fetchOrderListFxn = async (valData) => {
    let config = {
        params: {...valData},
        ...await getToken()
    }
    const {data} = await axios.get(getorderListUrl(), config);
    return data;
};

export const dashboardCountFxn = async (valData) => {
    let config = {
        params: {...valData},
        ...await getToken()
    }
    const {data} = await axios.get(dashboardCountUrl(), config);
    return data;
};

export const paymentGroupByPaymentMethodFxn = async (valData) => {
    const {data} = await axios.post(paymentGroupByPaymentMethodUrl(), valData, getToken());
    return data;
};

export const dateOpenFxn = (valData) => async (dispatch) => {
    dispatch(showLoader());
    let {data} = await axios.post(dateOpenUrl(), valData, getToken());
    dispatch(hideLoader());
    if (data.error) {
        notification.error({
            message: data.message || "Error",
        });
    } else {
        notification.success({
            message: data.message || "Success",
        });
    }
    return data;
};


export const dayCloseFxn = (valData) => async (dispatch) => {
    dispatch(showLoader());
    let {data} = await axios.post(dayCloseUrl(), valData, getToken());
    dispatch(hideLoader());
    if (data.error) {
        notification.error({
            message: data.message || "Error",
        });
    } else {
        notification.success({
            message: data.message || "Success",
        });
    }
    return data;
};
export const getCurrentDayOpenFxn = async (valData) => {
    let config = {
        params: {...valData},
        ...await getToken()
    }
    const {data} = await axios.get(getCurrentDayOpenUrl(), config);
    return data;
};
export const categorySalesSummaryFxn = async (valData) => {
    const {data} = await axios.post(categorySalesSummaryUrl(), valData, getToken());
    return data;
};
export const creditSaleSummaryFxn = async (valData) => {
    const { data } = await axios.post(creditSaleSummaryUrl(), valData, getToken());
    return data;
};
export const deleteTodayDayFxn = (valData) => async (dispatch) => {
    dispatch(showLoader());

    let {data} = await axios.post(deleteTodayDayUrl(), valData, getToken());

    dispatch(hideLoader());

    if (data.error) {
        notification.error({
            message: data.message || "Error",
        });
    } else {
        notification.success({
            message: data.message || "Success",
        });
    }

    return data;
};
